import { getTitlePicture, drawTitleBadge } from './TitleBadge';
export function attachFightTitle(scene:Phaser.Scene,id:number,target:Phaser.GameObjects.Container){
 if(!id)return;
 let badge:Phaser.GameObjects.Image|undefined,disposed=false;
 const textureKey=`overhead-title-${id}`;
 const update=(time:number)=>{
  if(disposed)return;
  if(!target.active){badge?.setVisible(false);return;}
  const image=getTitlePicture(id);if(!image)return;
  let texture=scene.textures.get(textureKey) as Phaser.Textures.CanvasTexture;
  if(!scene.textures.exists(textureKey))texture=scene.textures.createCanvas(textureKey,184,66)!;
  const context=texture.getContext();context.clearRect(0,0,184,66);drawTitleBadge(context,id,92,33,time);texture.refresh();
  if(!badge)badge=scene.add.image(target.x,target.y-145,textureKey).setDepth(1000);
  badge.setPosition(target.x,target.y-145).setVisible(target.visible&&target.active).setAlpha(target.alpha);
 };
 scene.events.on('update',update);
 scene.events.once('shutdown',()=>{disposed=true;scene.events.off('update',update);badge?.destroy();});
}
